import React, { Component } from 'react';

import * as types from 'misc/types';
import { isCorrectContentType } from 'misc/helpers';
import { API_URL } from 'misc/endpoint.js';

class InlineContentViewer extends Component {
    
    render = () => {
        const { customerId, content } = this.props;
       
        let inlineContent = '';
        let showPrintButton = false;

        if (content.isLoaded && content.data) {
            let contentURL =    API_URL.SERVICE +
                                'envelopes/' +
                                content.data.envelopeId +
                                '/body/' +
                                content.data.id +
                                '/data';
        
            // Show print button only for text and html
            if(isCorrectContentType(content.data.contentType, [types.CONTENT_TYPES.TEXT, types.CONTENT_TYPES.HTML])){
                showPrintButton = true;
            }

            // THIS IS A TEMP FIX ON AN ISSUE THAT DOESNT SHOW TEXT/PLAIN
            // if (isCorrectContentType(content.data.contentType, [types.CONTENT_TYPES.TEXT])) {
            //     // Show text directly on page, let digimail style it
            //     inlineContent = (
            //         <React.Fragment>
            //             <div className="content fill-parent" id="printf" name="printf">
            //                 <pre>
            //                     {content.data.data}
            //                 </pre>
            //             </div>
            //         </React.Fragment>
            //     );
            // }else {
                // Show html and pdf in an iframe, let them keep their own style
                inlineContent = (
                    <React.Fragment>
                        <div className="content fill-parent">
                            <iframe
                                title="Content"
                                className="fill-parent"
                                src={contentURL}
                                type={content.data.contentType}
                                frameBorder="0"
                                scrolling="no"
                                width="100%"
                                height="100%"
                                id="printf"
                                name="printf"
                            />
                        </div>
                    </React.Fragment>
                );
            // }
        }

        return <React.Fragment>
            {showPrintButton &&
                <button className="button-yellow button-print" onClick={() => this.print()}></button>
            }
            {inlineContent}
        </React.Fragment>;
    };

    print() {
        window.print();
    }

    expand() {
        const { data } = this.props;
        window.open('#/document/' + data.id, '_blank');
    }
}

export default InlineContentViewer;



// WEBPACK FOOTER //
// ./src/components/inbox/InlineContentViewer.js